"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MyBooks = void 0;
var _hooks = require("../../../../../hooks");
var _Menu = require("../../../../../UI/Menu");
var _MyBooks = require("./MyBooks.styles");
var _Book = require("../../Book.labels");
var _Tooltip = require("../../../../../UI/Tooltip");
var _Button = require("../../../../../UI/Button");
var _MyBooksToggle = require("./partials/MyBooksToggle");
var _jsxRuntime = require("react/jsx-runtime");
var MyBooks = function MyBooks(props) {
  var onRemoveBookFromMyBooks = props.onRemoveBookFromMyBooks,
    optionalData = props.optionalData,
    _props$view = props.view,
    view = _props$view === void 0 ? 'default' : _props$view;
  var getLabel = (0, _hooks.useLabels)({
    labels: _Book.labels
  });
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    isMobileView = _useDeviceData.isMobileView;
  var styles = (0, _MyBooks.useStyles)(props);
  var options = [{
    value: 'remove-book',
    label: getLabel('remove_from_my_books'),
    onClick: onRemoveBookFromMyBooks
  }];
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: styles['cc-Book__my-books'],
    children: view === 'horizontal' || isMobileView ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Menu.Menu, {
      options: options,
      btnProps: {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_MyBooksToggle.MyBooksToggle, {}),
        view: 'text',
        color: 'basic',
        onClick: function onClick(e) {
          e.preventDefault();
          e.stopPropagation();
        }
      }
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.Tooltip, {
      isInteractive: true,
      anchor: /*#__PURE__*/(0, _jsxRuntime.jsx)(_MyBooksToggle.MyBooksToggle, {}),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
        id: "ccRemoveFromMyooksButton",
        view: "text",
        size: "small",
        color: "basic",
        onClick: onRemoveBookFromMyBooks,
        category: "bookTile",
        label: "removeBook",
        optionalData: optionalData,
        children: getLabel('remove_from_my_books')
      })
    })
  });
};
exports.MyBooks = MyBooks;